import React, { useEffect, useState } from 'react'
import { ShowActivePeriodComponent } from '../Components/Period/ShowActivePeriodComponent'
import { Add_Reserve_Api, BackToSelectOther_Reserve_Api, GetById_Reserve_Api, OtherEnterCompleted_Reserve_Api, TimeSelectCompleted_Reserve_Api, UpdatePrimaryUserInfo_Reserve_Api } from '../API/ReserveApi';
import { OthersComponent } from '../Components/Reserve/OthersComponent';
import { TimesComponent } from '../Components/Reserve/TimesComponent';
import { ObjectsComponent } from '../Components/Reserve/ObjectsComponent';
import { Steps } from '../Components/Step/Steps';
import { Button, Col, Row } from 'antd';
import { PrimaryUserInfoComponent } from '../Components/Reserve/PrimaryUserInfoComponent';
import { EditableReserveComponent } from '../Components/Reserve/EditableReserveComponent';
// import { AdditionalFilesComponent } from '../Components/Reserve/AdditionalFilesComponent';
// ====================================================================== 
export const NewReserve = ({ setLoading, showMessage }) => {
  // ====================================================================== 
  const [view, setView] = useState('ActivePeriods');
  const [reserveId, setReserveId] = useState();
  const [version, setVersion] = useState(0);

  const [reserve, setReserve] = useState();
  const [period, setPeriod] = useState();

  const [mobile, setMobile] = useState();
  const [tel, setTel] = useState();
  const [address, setAddress] = useState();
  const [postalCode, setPostalCode] = useState();
  // ====================================================================== 
  useEffect(() => {
    if (reserveId)
      loadReserve(reserveId);
  }, [version]);
  // ====================================================================== 
  const periodClicked = (p) => {
    setPeriod(p);
    addReserve(p.id);
  }
  // ====================================================================== 
  const addReserve = async (periodId) => {
    setLoading(true);
    try {
      const data = await Add_Reserve_Api({ "periodId": periodId });
      setLoading(false);

      if (data.messageStatus == "Successful") {
        setReserveId(data.messageData.data);
        setView("SetOthers");
        setVersion(version + 1);
      }
      else
        showMessage(data.message, "error")
    }
    catch (error) {
      setLoading(false);
      showMessage("خطا در ارتباط با سرور.", "error")
    }
  }
  // ====================================================================== 
  const loadReserve = async (id) => {
    setLoading(true);
    try {
      const data = await GetById_Reserve_Api(id);
      setLoading(false);
      if (data.messageStatus == "Successful") {
        setReserve(data.messageData.data);
        setMobile(data.messageData.data.mobile);
        setTel(data.messageData.data.tel);
        setAddress(data.messageData.data.address);
        setPostalCode(data.messageData.data.postalCode);
      }
      else
        showMessage(data.message, "error")
    }
    catch (error) {
      setLoading(false);
      showMessage("خطا در ارتباط با سرور.", "error")
    }
  }
  // ====================================================================== 
  const updatePrimaryUserInfo = async () => {

    if (!mobile || mobile.trim() === "") {
        showMessage("شماره موبایل الزامی است.", "error");
        return false;
    }

    if (!/^09\d{9}$/.test(mobile)) {
        showMessage("شماره موبایل معتبر نیست.", "error");
        return false;
    }

    if (!address || address.trim().length < 8) {
        showMessage("آدرس باید حداقل ۸ کاراکتر باشد.", "error");
        return false;
    }

    setLoading(true);

    try {
        const data = await UpdatePrimaryUserInfo_Reserve_Api({
            id: reserve.id,
            mobile,
            tel,
            address,
            postalCode
        });

        setLoading(false);

        if (data.messageStatus === "Successful") {
            return true;
        }

        showMessage(data.message, "error");
        return false;
    }
    catch {
        setLoading(false);
        showMessage("خطا در ارتباط با سرور.", "error");
        return false;
    }
}
  // const updatePrimaryUserInfo = async () => {
  //   setLoading(true);
  //   try {
  //     const data = await UpdatePrimaryUserInfo_Reserve_Api({ "id": reserve.id, "mobile": mobile, "tel": tel, "address": address , "postalCode": postalCode  });
  //     setLoading(false);

  //     if (data.messageStatus == "Successful") {

  //     }
  //     else
  //       showMessage(data.message, "error")
  //   }
  //   catch (error) {
  //     setLoading(false);
  //     showMessage("خطا در ارتباط با سرور.", "error")
  //   }
  // }

  // ====================================================================== 
  const OtherEnterCompleted = async () => {
    setLoading(true);
    try {
      const data = await OtherEnterCompleted_Reserve_Api(reserve.id);
      setVersion(version + 1);
      setLoading(false);

      if (data.messageStatus == "Successful") {
      }
      else
        showMessage(data.message, "error")
    }
    catch (error) {
      setLoading(false);
      showMessage("خطا در ارتباط با سرور.", "error")
    }
  }
  // ====================================================================== 
  const TimeSelectCompleted = async () => {
    setLoading(true);
    try {
      const data = await TimeSelectCompleted_Reserve_Api(reserve.id);
      setVersion(version + 1);
      setLoading(false);

      if (data.messageStatus == "Successful") {
      }
      else
        showMessage(data.message, "error")
    }
    catch (error) {
      setLoading(false);
      showMessage("خطا در ارتباط با سرور.", "error")
    }
  }
  // ====================================================================== 
  const BackToSelectOther = async () => {
    setLoading(true);
    try {
      const data = await BackToSelectOther_Reserve_Api(reserve.id);
      setVersion(version + 1);
      setLoading(false);

      if (data.messageStatus == "Successful") {
      }
      else
        showMessage(data.message, "error")
    }
    catch (error) {
      setLoading(false);
      showMessage("خطا در ارتباط با سرور.", "error")
    }
  }
  // ====================================================================== 
  return (
    <>

      {view === "ActivePeriods" ? (
        <ShowActivePeriodComponent
          setLoading={setLoading}
          showMessage={showMessage}
          onNewReserveClick={(p) => periodClicked(p)}
        />
      ) : (
        <>
          {/* {view === "SetOthers" && reserve && reserve.reserveStatus == "Register" ? ( */}
          {reserve && reserve.reserveStatus == "Register" && reserve.period.getAdditionalFile ? (
            <>
              <Steps
                reserve={reserve}
                period={period}
                setLoading={setLoading}
                showMessage={showMessage}

                isShowPrev={false}
                isShowBack={false}
                isShowNext={true}
                //onNextClick={() => { updatePrimaryUserInfo(); OtherEnterCompleted(); }}
                onNextClick={async () => {

    const result = await updatePrimaryUserInfo();

    if (!result)
        return;

    await OtherEnterCompleted();
}}
                isEnableNext={true}
              />

              <OthersComponent
                mode={'Edit'}
                setLoading={setLoading}
                showMessage={showMessage}
                reserveId={reserve.id}
                reserve={reserve}
                showTitleBar={true}
                period={period}
                onPrimaryAdded={() => { loadReserve(reserveId) }}
              />

              <PrimaryUserInfoComponent
                setLoading={setLoading}
                showMessage={showMessage}
                mobile={mobile}
                tel={tel}
                address={address}
                setMobile={setMobile}
                setAddress={setAddress}
                setTel={setTel}
                setReserve={setReserve}
                postalCode={postalCode}
                setPostalCode={setPostalCode}
              />
              {/* <AdditionalFilesComponent
                                          reserve={reserve}
                                          period={reserve.period}
                                          setLoading={setLoading}
                                          showMessage={showMessage}
                                      /> */}
              <br />
              </>
          ) : reserve && reserve.reserveStatus == "Register" && !reserve.period.getAdditionalFile ? (
            <>
              <Steps
                reserve={reserve}
                period={period}
                setLoading={setLoading}
                showMessage={showMessage}

                isShowPrev={false}
                isShowBack={false}
                isShowNext={true}
                //onNextClick={() => { updatePrimaryUserInfo(); OtherEnterCompleted(); }}
                onNextClick={async () => {

    const result = await updatePrimaryUserInfo();

    if (!result)
        return;

    await OtherEnterCompleted();
}}
                isEnableNext={true}
              />

              <OthersComponent
                mode={'Edit'}
                setLoading={setLoading}
                showMessage={showMessage}
                reserveId={reserve.id}
                reserve={reserve}
                showTitleBar={true}
                period={period}
                onPrimaryAdded={() => { loadReserve(reserveId) }}
              />

              <PrimaryUserInfoComponent
                setLoading={setLoading}
                showMessage={showMessage}
                mobile={mobile}
                tel={tel}
                address={address}
                setMobile={setMobile}
                setAddress={setAddress}
                setTel={setTel}
                setReserve={setReserve}
                postalCode={postalCode}
                setPostalCode={setPostalCode}
              />
              <br />
              </>
          ) : (
            reserve && reserve.reserveStatus == "OtherEntered" ? (
              <>
                <Steps
                  reserve={reserve}
                  period={period}
                  setLoading={setLoading}
                  showMessage={showMessage}

                  isShowPrev={true}

                  onPrevClick={() => { BackToSelectOther(); setView("SetOthers"); }}
                  isShowNext={true}
                  isEnableNext={reserve.objectInstanceId ? true : false}
                  onNextClick={() => { TimeSelectCompleted(); setView("PreConfirmReserve") }}
//                   onNextClick={async () => {

//     const result = await updatePrimaryUserInfo();

//     if (!result)
//         return;

//     await OtherEnterCompleted();
// }}
                />

                <Row>
                  <Col xs={24} sm={24} md={8} lg={7} xl={7}>
                    <TimesComponent
                      setLoading={setLoading}
                      showMessage={showMessage}
                      reserve={reserve}
                      onTimeChanged={() => setVersion(version + 1)}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={16} lg={17} xl={17}>
                    <ObjectsComponent
                      setLoading={setLoading}
                      showMessage={showMessage}
                      reserve={reserve}
                      onObjectChanged={() => setVersion(version + 1)}
                    />
                  </Col>
                </Row>
              </>
            ) :
              (
                reserve && reserve.reserveStatus == "TimeSelected" ?
                  <>

                    <EditableReserveComponent
                      setLoading={setLoading}
                      showMessage={showMessage}
                      reserveId={reserveId}
                      period={period}
                    />
                  </>
                  : <></>
              )
          )}
        </>
      )}

    </>
  )
}
